var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_2430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.83341H1.75M9.33333 1.16675V3.50008M4.66667 1.16675V3.50008M4.55 12.8334H9.45C10.4301 12.8334 10.9201 12.8334 11.2945 12.6427C11.6238 12.4749 11.8915 12.2072 12.0593 11.8779C12.25 11.5036 12.25 11.0135 12.25 10.0334V5.13341C12.25 4.15332 12.25 3.66328 12.0593 3.28893C11.8915 2.95965 11.6238 2.69193 11.2945 2.52415C10.9201 2.33341 10.4301 2.33341 9.45 2.33341H4.55C3.56991 2.33341 3.07986 2.33341 2.70552 2.52415C2.37623 2.69193 2.10852 2.95965 1.94074 3.28893C1.75 3.66328 1.75 4.15332 1.75 5.13341V10.0334C1.75 11.0135 1.75 11.5036 1.94074 11.8779C2.10852 12.2072 2.37623 12.4749 2.70552 12.6427C3.07986 12.8334 3.56991 12.8334 4.55 12.8334Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_2430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.00a4db4b19842da6e7cc074c03eb906d.svg";
export { ForwardRef as ReactComponent };